/**
 * Converts a UI date string into the YYYYMMDD format the STP file API expects.
 *
 * Prefer an explicit MM/DD/YYYY parse so timezone offsets from `new Date(...)`
 * cannot shift the calendar day before it is sent as `date_from_filename_*`.
 *
 * @input dateStr - Date from the filter panel (MM/DD/YYYY or already YYYYMMDD)
 * @return Date string in YYYYMMDD, or the original value if parsing fails
 */
export const convertDateToAPIFormat = (dateStr: string): string => {
  if (/^\d{8}$/.test(dateStr)) {
    return dateStr;
  }

  const mmddyyyy = dateStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (mmddyyyy) {
    const [, month, day, year] = mmddyyyy;
    return `${year}${month.padStart(2, "0")}${day.padStart(2, "0")}`;
  }

  const date = new Date(dateStr);

  if (isNaN(date.getTime())) {
    return dateStr;
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}${month}${day}`;
};
